import Modal from "react-bootstrap/Modal";
import { useIntl } from "react-intl";
import { useEffect, useRef, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../redux/PlatfromSettingAction";
import { LOCALES } from "../../../i18n/locales";
import { getCookie } from "../../slidebar/components/DarkMode";
import { ApiStatusTypeEnum } from "../../../enumeration/ApiStatusTypeEnum";

export const UIWordingManage = ({
  languageShow,
  setLanguageShow,
  setSwalProps,
}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [uiWordingQuery, setUiWordingQuery] = useState({
    languagecode: LOCALES.ENGLISH,
    content: "",
    description: "",
  });
  const [mode, setMode] = useState(getCookie("selectedTheme"));

  const platformSettingState = useSelector(
    ({ platformSetting }) => platformSetting,
    shallowEqual
  );

  const handleClose = () => {
    setLanguageShow(undefined);
  };

  useEffect(() => {
    const handle = () => {
      setMode((prev) => (prev === "dark" ? "light" : "dark"));
    };

    window.addEventListener("setTheme", handle);

    return () => {
      window.removeEventListener("setTheme", handle);
    };
  }, []);

  useEffect(() => {
    setUiWordingQuery(
      languageShow ?? {
        languagecode: LOCALES.ENGLISH,
        content: "",
        description: "",
      }
    );
  }, [languageShow]);

  const saveValues = () => {
    setSwalProps({
      show: true,
      icon: "question",
      title: intl.formatMessage({ id: "confirmation" }),
      text: intl.formatMessage({ id: "questionManageUiWording" }),
      showCancelButton: true,
      onConfirm: () => {
        const newQueryParams = {
          action: "uiwordingupdate",
          ...uiWordingQuery,
        };

        dispatch(actions.updateUIWording(newQueryParams)).then((resp) => {
          resp = resp.data;

          if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
            const queryParams = {
              action: "uiwordinglist",
            };
            dispatch(actions.getUIWording(queryParams));
            setSwalProps({
              show: true,
              icon: "success",
              title: intl.formatMessage({ id: "success" }),
              text: intl.formatMessage({
                id: "updateSuccessfully",
              }),
              onConfirm: () => {
                handleClose();
              },
              onClose: () => {
                handleClose();
              },
            });
          } else {
            setSwalProps({
              show: true,
              icon: "error",
              title: intl.formatMessage({ id: "error" }),
              text: resp.message,
            });
          }
        });
      },
    });
  };

  return (
    <>
      <Modal
        show={!!languageShow}
        onHide={handleClose}
        centered
        size="xl"
        data-bs-theme={mode}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {intl.formatMessage({
              id: "manageUiWording",
            })}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-2">
            <label className="mb-2 text-input-label">
              {intl.formatMessage({ id: "language" })}
            </label>
            <select
              className="form-select"
              name="languagecode"
              onChange={(e) => {
                const wording =
                  platformSettingState.uiWording?.uiWordingLists?.find(
                    (wording) => wording.languagecode === e.target.value
                  );

                setUiWordingQuery(
                  wording ?? {
                    languagecode: e.target.value,
                    content: "",
                    description: "",
                  }
                );
              }}
              value={uiWordingQuery.languagecode}
            >
              <option value={LOCALES.ENGLISH}>
                {intl.formatMessage({ id: "english" })}
              </option>
              <option value={LOCALES.CHINESE}>
                {intl.formatMessage({ id: "chinese" })}
              </option>
              <option value={LOCALES.MALAY}>
                {intl.formatMessage({ id: "malay" })}
              </option>
              <option value={LOCALES.INDO}>
                {intl.formatMessage({ id: "indo" })}
              </option>
            </select>
          </div>
          <div className="mb-2">
            <label className="mb-2 text-input-label">
              {intl.formatMessage({ id: "description" })}
            </label>

            <input
              type="text"
              className="form-control"
              placeholder={intl.formatMessage({ id: "description" })}
              value={uiWordingQuery.description}
              onChange={(e) => {
                setUiWordingQuery((prev) => ({
                  ...prev,
                  description: e.target.value,
                }));
              }}
              disabled={true}
            />
          </div>
          <div className="mb-2">
            <label className="mb-2 text-input-label">
              {intl.formatMessage({ id: "content" })}
            </label>
            <input
              type="text"
              className="form-control"
              placeholder={intl.formatMessage({ id: "content" })}
              value={uiWordingQuery.content}
              onChange={(e) => {
                setUiWordingQuery((prev) => ({
                  ...prev,
                  content: e.target.value,
                }));
              }}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleClose}
          >
            {intl.formatMessage({ id: "close" })}
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={saveValues}
          >
            {intl.formatMessage({ id: "saveChanges" })}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
